import { Injectable } from '@angular/core';
import { loadModules } from 'esri-loader';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class EsriLoaderService {

  public esri: any;

  public resetForm: BehaviorSubject<boolean> = new BehaviorSubject(false);

  loadEsriObjects(): Promise<any>{
    return new Promise<any>((resolve, reject) => {
      return loadModules([
        'esri/config',
        'esri/Map',
        'esri/WebMap',
        'esri/views/MapView',
        'esri/geometry/support/webMercatorUtils',
        'esri/Graphic',
        'esri/layers/GraphicsLayer',
        'esri/geometry/SpatialReference',
        'esri/geometry/Point',
        'esri/views/2d/draw/Draw',
        'esri/views/2d/draw/PolygonDrawAction',
        'esri/core/Collection',
        'esri/layers/support/Field',
        'esri/layers/FeatureLayer',
        'esri/geometry/geometryEngine',
        'esri/widgets/Home',
        'esri/widgets/BasemapToggle',
        'esri/Basemap',
        'esri/views/layers/support/FeatureFilter',
        'esri/views/layers/support/FeatureEffect'
      ])
      .then(([
          Config,
          Map, 
          WebMap,
          MapView, 
          webMercatorUtils, 
          Graphic,
          GraphicsLayer,
          SpatialReference,
          Point,
          Draw,
          PolygonDrawAction,
          EsriCollection,
          Field,
          FeatureLayer,
          GeometryEngine,
          HomeWidget,
          BasemapToggle,
          Basemap,
          FeatureFilter,
          FeatureEffect
        ]) => {
        this.esri = {};
        this.esri.Config = Config, 
        this.esri.Map = Map;
        this.esri.WebMap = WebMap;
        this.esri.MapView = MapView;
        this.esri.webMercatorUtils = webMercatorUtils;
        this.esri.Graphic = Graphic;
        this.esri.GraphicsLayer = GraphicsLayer;
        this.esri.SpatialReference = SpatialReference;
        this.esri.Point = Point;
        this.esri.Draw = Draw;
        this.esri.PolygonDrawAction = PolygonDrawAction;
        this.esri.EsriCollection = EsriCollection;
        this.esri.Field = Field;
        this.esri.FeatureLayer = FeatureLayer;
        this.esri.GeometryEngine = GeometryEngine;
        this.esri.HomeWidget = HomeWidget;
        this.esri.BasemapToggle = BasemapToggle;
        this.esri.Basemap = Basemap;
        this.esri.FeatureFilter = FeatureFilter;
        this.esri.FeatureEffect = FeatureEffect;
        resolve(this.esri);
        
      })
    })
  }

  public selectedItem = new BehaviorSubject({});
  public selectedAccountNumber = new BehaviorSubject({});

  constructor() { }
}
